import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuroraLoaderComponent } from '../shared/aurora-loader.component';

@Component({
  selector: 'app-space-claim-status',
  standalone: true,
  imports: [CommonModule, AuroraLoaderComponent],
  template: `
    <app-aurora-loader
      *ngIf="loading"
      label="Loading event details"
    ></app-aurora-loader>

    <div *ngIf="!loading && !hasForm && !isAlreadyClaimed" class="error">
      <p>No event found or failed to load event data.</p>
    </div>
    
    <div *ngIf="!loading && !hasForm && isAlreadyClaimed" class="already-claimed">
      <h2>Event Already Claimed</h2>
      <p>This event has already been claimed by another organizer.</p>
      <p>If you believe this event should be available for claiming or if you need assistance, please contact us at <strong>contact@nx2u.app</strong>.</p>
    </div>
  `,
  styleUrls: ['./space-claim-status.component.scss']
})
export class SpaceClaimStatusComponent {
  @Input() loading: boolean = false;
  @Input() hasForm: boolean = false;
  @Input() isAlreadyClaimed: boolean = false;
} 